import { render, staticRenderFns } from "./MarketSummaryFuture.vue?vue&type=template&id=1be2e4f8"
import script from "./MarketSummaryFuture.vue?vue&type=script&lang=js"
export * from "./MarketSummaryFuture.vue?vue&type=script&lang=js"
import style0 from "./MarketSummaryFuture.vue?vue&type=style&index=0&id=1be2e4f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports